


export const DubbleCricle = () => {


    return(
        <div className={'doubleCircle'}>
            <svg width="566.000000" height="476.949341" viewBox="0 0 566 476.949" fill="none" xmlns="http://www.w3.org/2000/svg" >
                <circle id="Ellipse 2" cx="388.653320" cy="177.346680" r="177.346664" fill="#A900E4" fillOpacity="1.000000"/>
                <circle id="Ellipse 3" cx="177.346680" cy="299.602661" r="177.346664" fill="#A900E4" fillOpacity="1.000000"/>
            </svg>
        </div>
    )
}